module.exports = __webpack_public_path__ + "img/square.a0b554e9.png";